import {
    FETCH_GLOBALSEARCH_BEGIN,
    FETCH_GLOBALSEARCH_SUCCESS,
    FETCH_GLOBALSEARCH_FAILURE
} from '../constants/globalsearch';

const initialState = {
    AllEntities: [],
    isLoading: false,
    error: ""
}
export const GetAllGlobalEntitiesReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_GLOBALSEARCH_BEGIN: {
            return {
                ...state,
                isLoading: true,
                AllEntities:[]
            };
        }
        case FETCH_GLOBALSEARCH_FAILURE:
            return {
                ...initialState,
                isLoading: false,
                AllEntities: [],
            };
        case FETCH_GLOBALSEARCH_SUCCESS:
            return {
                ...initialState,
                AllEntities: payload.AllEntities,
                isLoading: false,
            };
        default:
            return state;
    }
}
export default GetAllGlobalEntitiesReducer
